import React, { Fragment } from 'react';
import Footer from '../../components/footer';
import LiveProgramSection from '../../components/LiveProgramSection';
import PageTitle from '../../components/pagetitle';
import Scrollbar from '../../components/scrollbar';

const LiveProgramPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={'Event'} pagesub={'Event'} />

      <LiveProgramSection pbClass={'pb-0'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default LiveProgramPage;
